import defaultCartState from './CartProvider';

const cartReducer = (state, action) => {
  const calc_total = (curr, i) => curr + (parseInt(i.price) - parseInt(i.discount));
  let newItems = [];
  let newTotal = 0;
  switch (action.type) {
    case 'ADD_ITEM':
      newItems = [...state.items, action.payload];
      newTotal = newItems.reduce(calc_total, 0);
      return { items: newItems, totalAmount: newTotal };

    case 'REMOVE_ITEM':
      newItems = state.items.filter((f, index) => index !== action.payload);
      newTotal = newItems.reduce(calc_total, 0);
      return { items: newItems, totalAmount: newTotal };

    case 'CLEAR':
      return { items: [], totalAmount: 0 };
      
    case 'SHOW_FOOTER':
      return { items: state.items, totalAmount: state.totalAmount, showFooter: action.payload };
      
    default:
      return defaultCartState;
  }
};

export default cartReducer;
